import './settings.less';
import register from '@kpsys/angularjs-register';
import SettingsController from './settings.controller';
import SettingsDataService from './settings.data-service';
import {SettingsService} from './settings.service';

export default register('uc-settings')
    .service(SettingsDataService.serviceName, SettingsDataService)
    .service(SettingsService.serviceName, SettingsService)
    .controller(SettingsController.controllerName, SettingsController)
    .name();
